const GrilleDesProgrammesIntegrated = ({language , token}) => {
    const newGrilleDesProgrammesIframe = "https:" +
    window.process.env.URL_GrilleDesProgrammes
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_GrilleDesProgrammes_display"
        src={newGrilleDesProgrammesIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default GrilleDesProgrammesIntegrated